<template>
  <article class="project doodles">
    <main class="project-about doodles__content">
      <section>
        <h1>Doodles</h1>
        <p>
          I doodle at times.
        </p>
      </section>
      <section>
        <p>
          More on
          <a
            href="https://www.instagram.com/lines_and_patterns/"
            target="_blank"
            rel="noopener noreferrer"
            class="link-canvas"
            >Instagram</a
          >
        </p>
      </section>
    </main>
    <section class="doodles__message text_align_center">
      <p class="text-smaller">
        The whole page is a blank canvas. Doodle away!
      </p>
    </section>

    <canvas
      class="doodles__canvas"
      id="doodle-canvas"
      ref="doodle-canvas"
      @mousedown="startDrawing"
      @mousemove="keepDrawing"
      @touchstart="startDrawing"
      @touchmove="keepDrawing"
      @mouseout="keepCanvasFocus"
      @touchcancel="keepCanvasFocus"
    >
    </canvas>
  </article>
</template>

<script>
export default {
  data() {
    return {
      canvas: null,
      ctx: null,
      painting: false,
      x: 0,
      y: 0,
      offset: null,
      imageUrls: [
        '/assets/images/projects/Doodles/doodle_1.png',
        '/assets/images/projects/Doodles/doodle_2.png',
        '/assets/images/projects/Doodles/doodle_3.png'
      ],

      images: []
    }
  },
  methods: {
    getSize: function() {
      this.canvas.width = this.canvas.parentElement.clientWidth
      this.canvas.height = this.canvas.parentElement.clientHeight
    },
    startDrawing: function(e) {
      this.painting = true
      let rect = e.target.getBoundingClientRect()
      if (e.touches) {
        let touch = e.touches[0]
        this.x = touch.clientX - rect.left
        this.y = touch.clientY - rect.top
      } else {
        this.x = e.offsetX
        this.y = e.offsetY
      }
    },
    keepDrawing: function(e) {
      if (this.painting) {
        let cX, cY
        let rect = e.target.getBoundingClientRect()
        if (e.touches) {
          let touch = e.touches[0]
          cX = touch.clientX - rect.left
          cY = touch.clientY - rect.top
        } else {
          cX = e.offsetX
          cY = e.offsetY
        }

        this.ctx.beginPath()
        this.ctx.strokeStyle = '#f8f8f8'
        this.ctx.moveTo(this.x, this.y)
        this.ctx.lineTo(cX, cY)
        this.ctx.stroke()
        this.x = cX
        this.y = cY
      }
    },
    stopDrawing: function() {
      this.painting = false
      document.body.classList.remove('unselectable')
    },
    keepCanvasFocus: function() {
      document.body.classList.add('unselectable')
    },
    loadImages: function() {
      let promises = this.imageUrls.map(src => {
        let prom = new Promise(resolve => {
          let img = new Image()
          img.src = src
          img.onload = () => {
            this.images.push(img)
            resolve()
          }
        })
        return prom
      })

      Promise.all(promises).then(() => {
        this.allLoaded()
      })
    },
    resizeImage: function(image) {
      let x = this.ctx.canvas.clientWidth,
        y = this.ctx.canvas.clientHeight
      let scale,
        currentScale = 1,
        stepScale = 0.5
      if (x < 600) {
        scale = (x * 0.6) / image.width
      } else {
        scale = Math.min(x / (3 * image.width), (y - 360) / image.height)
      }
      while (currentScale * stepScale > scale) {
        currentScale *= stepScale
        image = this.stepScale(image)
      }

      return { image: image, remainingScale: scale / currentScale, scale }
    },
    stepScale: function(img) {
      let stepScale = 0.5
      let temp = {}
      temp.canvas = document.createElement('canvas')
      temp.ctx = temp.canvas.getContext('2d')

      temp.canvas.width = img.width * stepScale + 1
      temp.canvas.height = img.height * stepScale + 1
      temp.ctx.scale(stepScale, stepScale)
      temp.ctx.drawImage(img, 0, 0)
      return temp.canvas
    },
    allLoaded: function() {
      let x = this.ctx.canvas.clientWidth,
        y = 200
      this.images.forEach((img, index) => {
        let oc = document.createElement('canvas'),
          octx = oc.getContext('2d')

        let scaledData = this.resizeImage(img)

        oc.width = Math.floor(img.width * scaledData.scale) + 4
        oc.height = Math.floor(img.height * scaledData.scale) + 4
        octx.scale(scaledData.remainingScale, scaledData.remainingScale)
        octx.drawImage(scaledData.image, 1, 1)
        if (x < 600) {
          this.ctx.drawImage(oc, x * 0.2, y, oc.width, oc.height)
          y += oc.height + 8
        } else {
          this.ctx.drawImage(oc, (x / 3.8) * index, 200, oc.width, oc.height)
        }
      })
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.canvas = this.$refs['doodle-canvas']
      this.getSize()
      this.ctx = this.canvas.getContext('2d')
      this.loadImages()
    })
  },
  created: function() {
    window.addEventListener('mouseup', this.stopDrawing)
    window.addEventListener('touchend', this.stopDrawing)
    window.addEventListener('resize', this.getSize)
  },
  destroyed: function() {
    window.removeEventListener('mouseup', this.stopDrawing)
    window.removeEventListener('touchend', this.stopDrawing)
    window.removeEventListener('resize', this.getSize)
  }
}
</script>

<style scoped>
.doodles {
  width: 100%;
  height: calc(100vh + 120vw);
  position: relative;
  color: var(--bg-color);
}
.doodles__content {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  padding: var(--padding-sm);
  pointer-events: none;
}
.doodles__message {
  position: absolute;
  width: 100%;
  z-index: 10;
  pointer-events: none;
  animation: slidein 2s ease-in-out;
}
.doodles-grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
  grid-gap: var(--padding-sm);
}
.doodle {
  width: 80%;
  margin: auto;
}
.doodles__canvas {
  background: var(--primary-color);
}
.link-canvas {
  pointer-events: auto;
}

@keyframes slidein {
  0% {
    transform: scale(1, 1) translateY(-100%);
  }
  30% {
    transform: scale(0.9, 1.1) translateY(-100%);
  }
  50% {
    transform: scale(1.05, 0.95) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(-7%);
  }
  64%,
  100% {
    transform: scale(1, 1) translateY(0);
  }
}

@media only screen and (min-width: 60rem) {
  .doodles {
    height: 99vh;
    width: calc(98vw - 16rem);
  }
}
.doodles__content {
  padding: var(--padding-lg);
}
</style>
